import React, { useEffect } from 'react';
import { makeStyles } from "@mui/styles";
import { Button, Drawer } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import clsx from 'clsx';
import MessageContent from './MessageContent'
import { useTranslation } from 'react-i18next';

export default function WorkstationNotificationsDrawer(props) {
    const classes = useStyles();
    const { t } = useTranslation();

    return <Drawer variant="temporary" className={classes.drawer} anchor='right' open={props.drawerOpen} classes={{ paper: clsx({ [classes.drawerOpen]: props.drawerOpen, [classes.drawerClose]: !props.drawerOpen, }), }} onClose={() => props.closeDrawer()} transitionDuration={500}>
        <div className={classes.drawerBody}>
            <div className={classes.header}>
                <div className={classes.title}>{t("Notifications")}</div>
                <div className={classes.close}>
                    <Button className={classes.closeButton} onClick={() => props.openDrawer(false)}>
                        <CloseIcon className={classes.closeButtonIcon}></CloseIcon>
                    </Button>
                </div>
            </div>
            <div className={classes.body}>
                <div className={classes.messagesContainer}>
                    {(props.notifications !== undefined && props.notifications !== null && props.notifications.length > 0) && props.notifications.map(z => <MessageContent message={z} key={z.Id} textWidth={"80%"} iconPadding={"8px"} messageHeight={"65px"} backgroundColor={"white"}></MessageContent>)}
                </div>
            </div>
        </div>
    </Drawer>
}

const useStyles = makeStyles(() => ({
    drawerBody: {
        width: "100%",
        height: "100%",
        background: 'linear-gradient(#EFEFEF,#FFFFFF)',
        padding: "20px",
        paddingTop: "10px",
        boxSizing: "border-box"
    },
    closeButton: {
        float: 'right',
        "&:hover": {
            background: "#EFEFEF"
        },
        paddingRight: "0px !important",
        width: "25px !important",
        height: "25px !important",
        minWidth: "0px !important",
    },
    closeButtonIcon: {
        marginRight: "6px"
    },
    drawerOpen: {
        width: "30%",
    },
    drawerClose: {
        width: 0
    },
    close: {
        width: "20%",
        display: "inline-block",
        verticalAlign: "top"
    },
    title: {
        width: "80%",
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        marginTop: "10px",
        display: "inline-block"
    },
    header: {
        width: "100%",
        height: "auto",
        marginBottom: "20px"
    },
    messageButton: {
        border: "none",
        outline: "none",
        cursor: "pointer",
        width: "100%",
        textAlign: "left",
        backgroundColor: "#EFEFEF"
    }
}));